module.exports = __webpack_public_path__ + "img/step3.8e6ffe86.png";